import React, {useContext} from 'react';
import block from 'bem-cn-lite';
import {Icon} from '@yandex-data-ui/common';

import ServicesDataContext from 'contexts/ServicesDataContext';

import './ServiceIcon.scss';

export interface ServiceIconProps {
    name?: string;
    icon?: string | null;
    className?: string;
    size?: number;
}

const DEFAULT_ICON_SIZE = 16;
const b = block('ServiceIcon');

const ServiceIcon: React.FC<ServiceIconProps> = ({
    name,
    icon,
    className,
    size = DEFAULT_ICON_SIZE,
}) => {
    const {icons} = useContext(ServicesDataContext);
    const serviceIcon = icon || (name && icons[name]);

    if (!serviceIcon) {
        return null;
    }

    return <Icon data={serviceIcon} className={b(null, className)} size={size} />;
};

export default ServiceIcon;
